module.exports = __webpack_public_path__ + "img/MagneticGolf_512.0a30190c.jpg";